<template>
<div class="position-relative " style="background-color: #f3f3f3;min-height: 100dvh;">

    <div style="padding: 1.1875rem 1rem 0.3125rem 1.25rem;position: sticky;top: 0;background-color: #f3f3f3">
       <div class="d-flex align-items-center justify-content-between">
         <svg  @click="$router.back()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7.536 6.26401C7.36539 6.10503 7.13974 6.01849 6.90658 6.0226C6.67342 6.02672 6.45095 6.12117 6.28606 6.28606C6.12116 6.45096 6.02671 6.67342 6.02259 6.90658C6.01848 7.13975 6.10503 7.3654 6.264 7.53601L10.728 12L6.264 16.464C6.17558 16.5464 6.10466 16.6458 6.05547 16.7562C6.00628 16.8666 5.97983 16.9857 5.97769 17.1066C5.97556 17.2274 5.99779 17.3475 6.04306 17.4595C6.08832 17.5716 6.1557 17.6734 6.24116 17.7589C6.32662 17.8443 6.42842 17.9117 6.54049 17.957C6.65255 18.0022 6.77259 18.0245 6.89343 18.0223C7.01427 18.0202 7.13345 17.9937 7.24385 17.9445C7.35425 17.8954 7.45361 17.8244 7.536 17.736L12 13.272L16.464 17.736C16.5464 17.8244 16.6458 17.8954 16.7562 17.9445C16.8666 17.9937 16.9857 18.0202 17.1066 18.0223C17.2274 18.0245 17.3475 18.0022 17.4595 17.957C17.5716 17.9117 17.6734 17.8443 17.7589 17.7589C17.8443 17.6734 17.9117 17.5716 17.957 17.4595C18.0022 17.3475 18.0244 17.2274 18.0223 17.1066C18.0202 16.9857 17.9937 16.8666 17.9445 16.7562C17.8954 16.6458 17.8244 16.5464 17.736 16.464L13.272 12L17.736 7.53601C17.895 7.3654 17.9815 7.13975 17.9774 6.90658C17.9733 6.67342 17.8788 6.45096 17.714 6.28606C17.5491 6.12117 17.3266 6.02672 17.0934 6.0226C16.8603 6.01849 16.6346 6.10503 16.464 6.26401L12 10.728L7.536 6.26401Z" fill="black" />
        </svg>
       
        

       </div>

    </div>
    <h2  class="main-title" style="padding: 1.25rem 1rem 0 1.25rem;">Privacy Policy </h2>
    <div style="padding: 2.25rem 1.25rem 1.25rem 1.25rem;gap:1.25rem">
      

    </div>
    
    

</div>
</template>

<script>
import { showToast } from "@/main";
export default {
    name: "NotificationPage",
    components: {

    },

    data() {
        return {
          

        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        handleClick() {
      showToast("Successfully Added", 2000);
    }

    }

}
</script>

<style>
@import "./style/style.css";
</style>
